var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.accessable
    ? _c(
        "div",
        {
          ref: "supsisRightModal",
          staticClass: "supsis-right-modal-wrapper",
          class:
            ((_obj = { closed: _vm.closed }),
            (_obj[_vm.type] = true),
            (_obj["zero-padding"] = !!_vm.fullShow),
            (_obj["footer-disabled"] = !_vm.footer),
            _obj),
          style: { width: _vm.width, zIndex: _vm.zIndex },
          attrs: { id: "supsis-right-modal" },
        },
        [
          _c("div", { staticClass: "action-buttons" }, [
            _c(
              "div",
              {
                staticClass: "btnWindow closeAction",
                on: { click: _vm.closeModal },
              },
              [_c("div", { staticClass: "material-icons" }, [_vm._v("close")])]
            ),
            _vm._v(" "),
            _vm.sliderOptions()
              ? _c(
                  "div",
                  {
                    staticClass: "btnWindow prevAction",
                    class: {
                      disabled:
                        _vm.sliderOptions() &&
                        !_vm.sliderOptions().prevAvailable,
                    },
                    on: {
                      click: function () {
                        return _vm.sliderOptions() &&
                          _vm.sliderOptions().prevAvailable
                          ? _vm.sliderOptions().prev()
                          : _vm.$_.noop()
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "material-icons" }, [
                      _vm._v("arrow_back_ios"),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.sliderOptions()
              ? _c(
                  "div",
                  {
                    staticClass: "btnWindow nextAction",
                    class: {
                      disabled:
                        _vm.sliderOptions() &&
                        !_vm.sliderOptions().nextAvailable,
                    },
                    on: {
                      click: function () {
                        return _vm.sliderOptions() &&
                          _vm.sliderOptions().nextAvailable
                          ? _vm.sliderOptions().next()
                          : _vm.$_.noop()
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "material-icons" }, [
                      _vm._v("arrow_forward_ios"),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.type !== "show-visitor" && !_vm.fullShow
            ? _c("div", { staticClass: "head" }, [
                _vm.type === "editor-task"
                  ? _c(
                      "div",
                      {
                        staticClass: "title",
                        attrs: { contenteditable: "true" },
                        on: { input: _vm.updateTitle },
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(_vm.title) + "\n        "
                        ),
                      ]
                    )
                  : _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.title)),
                    ]),
                _vm._v(" "),
                _c("div", { staticClass: "description" }, [
                  _vm._v(_vm._s(_vm.description)),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content",
              attrs: {
                "data-type": _vm.type.includes("table-record-viewer")
                  ? "table-record-viewer"
                  : _vm.type,
              },
            },
            [
              _c(
                "a-spin",
                { attrs: { spinning: _vm.loading } },
                [
                  _vm.type === "create-task"
                    ? _c(
                        "CreateTaskForm",
                        _vm._b(
                          {
                            attrs: {
                              "window-type": "create-task",
                              attachmentEditVisible: false,
                            },
                            on: { "update-form": _vm.updateForm },
                          },
                          "CreateTaskForm",
                          _vm.payload || {},
                          false
                        )
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "create-workflow"
                    ? _c("WorkflowForm", {
                        on: { "update-form": _vm.updateForm },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "task-settings"
                    ? _c("TaskSettings", {
                        on: { "update-form": _vm.updateForm },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "editor-task"
                    ? _c("EditorTask", {
                        attrs: { details: _vm.payload },
                        on: {
                          "update-form": _vm.updateForm,
                          "close-modal": _vm.closeModal,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "preview-task"
                    ? _c("PreviewTask", { attrs: { details: _vm.payload } })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "edit-task"
                    ? _c(
                        "CreateTaskForm",
                        _vm._b(
                          {
                            attrs: {
                              "window-type": "edit-task",
                              attachmentFileVisible: false,
                            },
                            on: { "update-form": _vm.updateForm },
                          },
                          "CreateTaskForm",
                          _vm.payload,
                          false
                        )
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "visibility-workflow"
                    ? _c("VisibilityWorkFlow", {
                        attrs: { details: _vm.payload },
                        on: { "update-form": _vm.updateForm },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "pipeline-edit"
                    ? _c("PipelineStageForm", {
                        attrs: { details: _vm.payload },
                        on: { "update-form": _vm.updateForm },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "edit-workflow"
                    ? _c("WorkflowForm", {
                        attrs: { details: _vm.payload },
                        on: { "update-form": _vm.updateForm },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "show-visitor"
                    ? _c("VisitorDetail", {
                        attrs: { visitorId: _vm.payload.visitorId },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "calendar-settings"
                    ? _c("CalendarSettings", {
                        attrs: { payload: _vm.payload },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "task-archive"
                    ? _c("TaskArchive", {
                        attrs: { workflow: _vm.payload.workflow },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "task-done"
                    ? _c("TaskDone", {
                        attrs: { workflow: _vm.payload.workflow },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "chat-create-task"
                    ? _c(
                        "ChatCreateTaskForm",
                        _vm._b(
                          {
                            attrs: {
                              "window-type": "chat-create-task",
                              attachmentEditVisible: false,
                            },
                            on: { "update-form": _vm.updateForm },
                          },
                          "ChatCreateTaskForm",
                          _vm.payload || {},
                          false
                        )
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type.includes("table-record-viewer")
                    ? _c("RecordViewer", {
                        attrs: {
                          tableId: _vm.payload.tableId,
                          recordId: _vm.payload.recordId,
                          defaultOpenTab: _vm.payload.defaultOpenTab,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "id-finder" ? _c("IDFinder") : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "grid-chat-window-contact"
                    ? _c("GridChatWindowContact", {
                        attrs: {
                          contactId: _vm.payload.contactId,
                          "disabled-resize": true,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.footer && !_vm.fullShow
            ? _c("div", { staticClass: "footer" }, [
                _c(
                  "div",
                  {
                    staticClass: "classic-submit-button",
                    class: { disabled: _vm.saving },
                    style: { pointerEvents: _vm.saving ? "none" : "auto" },
                    on: {
                      click: function ($event) {
                        return _vm.saveChanges(_vm.type)
                      },
                    },
                  },
                  [
                    _vm.type === "create-task" && _vm.saving
                      ? _c("a-icon", {
                          staticStyle: { "margin-right": "8px" },
                          attrs: { type: "loading" },
                        })
                      : _vm._e(),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("wp.saveChanges")) +
                        "\n        "
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "classic-submit-button",
                    attrs: { type: "normal" },
                    on: {
                      click: function () {
                        return _vm.closeModal("cancel-button")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("wp.cancel")) +
                        "\n        "
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }